export default __webpack_public_path__ + "static/media/4425aac5591aa23e1ffe63d6d8a8fc011580827071234.1fbefda2.webp";